import { Box, Divider, Typography } from '@mui/material';
import { sharedStyles } from '../../utils/Style';
import {
  GeneralSettingsTab,
  SettingsTabDef,
} from '../../interfaces/Settings/SettingsTab';
import { GeneralSettingsTabs } from './GeneralSettingsTabs';

interface GeneralSettingsPageProps {
  tab: SettingsTabDef<GeneralSettingsTab>;
}

export const GeneralSettingsPage = (props: GeneralSettingsPageProps) => {
  return (
    <Box sx={{ ...sharedStyles.pageBody }}>
      <GeneralSettingsTabs selectedTab={props.tab.kind} />
      <Box sx={{ p: 3 }}>
        <Typography variant='h5' sx={{ ...sharedStyles.pageTitle }}>
          {props.tab.name}
        </Typography>
        <Divider sx={{ mt: -2, mb: 1.5 }} />
        {props.tab.element}
      </Box>
    </Box>
  );
};
